const contactData = {
  mail: 'info@ading.be',
  address: 'Zinnialaan 33 2950 Kapellen Belgium',
  vat: 'BE 0471.911.235',
  phone: '32(0)485.75.78.69',
};

export default contactData;
